<template>
  <refund-list :shopType="1"></refund-list>
</template>

<script>

import RefundList from "@view/components/order/refund-list.vue";

export default {

  name: "refund",
  components: {RefundList},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
